import React, { Dispatch, PropsWithChildren, SetStateAction } from "react";
import "./termsAndConditionsStyles.css";

import { ChatGPCLogomark } from "../../Logos/Logos";
import { useTermsAndConditions } from "../../../hooks";
import { LanguageList } from "../Info/LanguageList";

import { display, supportedLanguages } from "../../../utils/displayValues";
import { LoadingPage } from "../LoadingPage";
import { GuidanceInfoContent } from "../Info/GuidanceInfoContent";

type TermsAndConditionsProps = {
  language: supportedLanguages;
  setLanguage: Dispatch<SetStateAction<supportedLanguages>>;
};

export const TermsAndConditions = ({ setLanguage, language, children }: PropsWithChildren<TermsAndConditionsProps>) => {
  const { termsAndConditions, declineTermsAndConditions, approveTermsAndConditions } = useTermsAndConditions();

  const handleAccept = () => {
    approveTermsAndConditions();
  };

  const handleDecline = () => {
    declineTermsAndConditions();
  };

  if (termsAndConditions?.accepted === false) {
    return (
      <div className="terms-wrapper">
        <div className="terms-header-bar">
          <ChatGPCLogomark />
        </div>
        <div className="terms-content">
          <LanguageList language={language} setLanguage={setLanguage} />
          <div className="terms-buttons-wrapper">
            <div className="terms-body">
              <GuidanceInfoContent language={language} />
            </div>
            <div className="red-text">{display[language].guidanceDisclaimer}</div>
            <div className="button-group">
              <button onClick={handleDecline} className="decline-button" data-testid="decline-terms">
                {display[language].decline}
              </button>
              <button data-testid="accept-terms" className="accept-button" onClick={handleAccept}>
                {display[language].accept}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (termsAndConditions?.accepted === true) {
    return <>{children}</>;
  }

  return <LoadingPage />;
};
